import { createActions, Store } from 'reflux'

export var ModalActions = createActions(['SetModal', 'SetModalWithParams', 'SetParams', 'UpdateParams'])

export class ModalStore extends Store {
	constructor() {
		super()
		this.state = {
			currentModal: null,
			denied: null
		}
		this.listenables = ModalActions
	}

	onSetModal(currentModal) {
		this.setState({ currentModal })
	}

	onSetModalWithParams(currentModal, params) {
		this.setState({ currentModal, ...params })
	}

	onSetParams(params) {
		this.setState(params)
	}

	onUpdateParams(params) {
		this.setState(params)
	}
}

ModalStore.id = 'modal'
